import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const MagentoEcommerceWebDesignInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Magento E-commerce Web Design in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Your Magento Partner</Subheading>}
        heading={
          <Heading>
            Magento <span tw="text-primary-500">E-commerce Web Design</span> in
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in Magento e-commerce web design in
            **Dubai**, crafting robust, scalable, and visually stunning online
            stores tailored to your business. Elevate your brand with our expert
            Magento solutions.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1577563908411-5077b6dc7624?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Design Your Magento Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Premier Magento Web Design in Dubai"
        description="We deliver Magento stores built for success."
        cards={[
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Custom Designs",
            description: "Unique Magento stores tailored to your brand.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Conversion Focused",
            description: "Optimized to drive sales and engagement.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Scalable Solutions",
            description: "Supports growth with Magento Enterprise.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Framework",
            description: "Advanced security for safe transactions.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Responsive Layouts",
            description: "Seamless shopping on all devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Designers",
            description: "Dubai’s top Magento experts.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Magento Design Process"
        description={
          <Description>
            We create your Magento store with expertise:
            <ul tw="mt-4 list-disc pl-6">
              <li>Discovery: Align with your business vision.</li>
              <li>Design: Craft a custom, user-friendly interface.</li>
              <li>Development: Build advanced features and extensions.</li>
              <li>Integration: Connect payment and inventory systems.</li>
              <li>Launch: Deploy a high-performance store.</li>
              <li>Support: Offer ongoing optimization and updates.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1559028012-481c04fa702d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Development workflow
          "https://images.unsplash.com/photo-1522542550221-31fd19575a2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Team collaboration
          "https://images.unsplash.com/photo-1517292987719-0369a794ec0f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce analytics
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Magento Success in Dubai"
        description="Our designs empower businesses to excel."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Boost",
            description: "Magento store increased revenue by 190%.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Efficient Launch",
            description: "Store live in just three weeks.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "97% satisfaction with Magento projects.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Scale?</Subheading>}
        heading="Magento E-commerce Web Design in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for expert Magento e-commerce web design
            in Dubai. Build a powerful, scalable, and stunning online
            store—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1472289065668-ce650ac443d2?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
